import { type FC } from 'react';
import styled from 'styled-components';

import { ConnectPopover } from '@/components/Pretzel/ConnectPopover';
import { Show } from '@/components/Show';

interface HelperProps {
  id: string;
  title?: string;
  description: string;
}

interface Props {
  title: string;
  hint?: string;
  helperProps?: HelperProps;
}

export const WidgetHeader: FC<Props> = ({ title, hint, helperProps }) => {
  // Check that either title or description is not empty, as they are normally
  // fetched from FMS and we don't want to render an empty popover when text is
  // missing in FMS.
  const showHelperIcon = !!helperProps?.title || !!helperProps?.description;

  return (
    <Container>
      <h3>{title}</h3>
      {showHelperIcon && (
        <ConnectPopover
          id={helperProps.id}
          title={helperProps.title}
          description={helperProps.description}
        />
      )}
      <Show when={!!hint}>
        <DivWithMargin className="font-details">{hint}</DivWithMargin>
      </Show>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const DivWithMargin = styled.div`
  margin-left: auto;
`;
